// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConfirmStepper_container__8Tz5E {
  justify-content: center;
}

.ConfirmStepper_container__8Tz5E .ConfirmStepper_init__-QVzg {
  animation: ConfirmStepper_init__-QVzg 0.3s 0.5s both;
}

.ConfirmStepper_container__8Tz5E .ConfirmStepper_item__4RHdf h4 {
  font-size: 1.2rem;
  font-weight: 400;
  margin-bottom: 5px;
}

.ConfirmStepper_container__8Tz5E .ConfirmStepper_item__4RHdf p {
  font-size: 1.1rem;
  font-weight: 300;
  margin: 0;
  margin-top: 5px;
}

.ConfirmStepper_container__8Tz5E .ConfirmStepper_address__Eh1A\\+ {
  font-size: 1rem;
  font-weight: 400;
  margin: 0;
  margin-top: 3px;
  opacity: 0.7;
}

.ConfirmStepper_container__8Tz5E .ConfirmStepper_tableContainer__EaKGr {
  animation: ConfirmStepper_init__-QVzg 0.3s;
  border-radius: 5px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.129);
}

@keyframes ConfirmStepper_init__-QVzg {
  0% {
    opacity: 0;
    transform: translateX(-20px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Remitos/Create/Steppers Refactor/ConfirmStepper/ConfirmStepper.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,oDAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA;EACE,0CAAoB;EACpB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".container {\n  justify-content: center;\n}\n\n.container .init {\n  animation: init 0.3s 0.5s both;\n}\n\n.container .item h4 {\n  font-size: 1.2rem;\n  font-weight: 400;\n  margin-bottom: 5px;\n}\n\n.container .item p {\n  font-size: 1.1rem;\n  font-weight: 300;\n  margin: 0;\n  margin-top: 5px;\n}\n\n.container .address {\n  font-size: 1rem;\n  font-weight: 400;\n  margin: 0;\n  margin-top: 3px;\n  opacity: 0.7;\n}\n\n.container .tableContainer {\n  animation: init 0.3s;\n  border-radius: 5px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.129);\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n    transform: translateX(-20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ConfirmStepper_container__8Tz5E`,
	"init": `ConfirmStepper_init__-QVzg`,
	"item": `ConfirmStepper_item__4RHdf`,
	"address": `ConfirmStepper_address__Eh1A+`,
	"tableContainer": `ConfirmStepper_tableContainer__EaKGr`
};
export default ___CSS_LOADER_EXPORT___;
